import { post } from "../index";

export const createInvite = (data) => {
  return post("/invites", data);
};
